import React, { useMemo } from 'react'
import { titleize } from 'util/strings'
import { moneyString } from 'util/currency'
import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'

const LineItem = ({ lineItem, integration }) => {
  const storeDomain = integration.storeDomain
  const itemId = lineItem.id.replace(/[^\d]*/, '')
  const url = `https://${storeDomain}.myshopify.com/admin/products/${itemId}`
  const discountedShopMoney = lineItem.discountedUnitPriceSet.shopMoney
  const totalShopMoney = lineItem.discountedTotalSet.shopMoney
  const itemText = useMemo(
    () => {
      return `${moneyString(discountedShopMoney)} x ${lineItem.currentQuantity}`
    },
    [discountedShopMoney, lineItem]
  )

  return (
    <>
      <p>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {lineItem.name}
        </a>
      </p>
      <p>
        {itemText} {moneyString(totalShopMoney)}
      </p>
    </>
  )
}

const FulfillmentTrackingRow = info => {
  return (
    <p>
      {info.company}
      <a href={info.url} target="_blank" rel="noopener noreferrer">
        {info.number}
      </a>
    </p>
  )
}

const FulfillmentRow = fulfillment => {
  if (!fulfillment.trackingInfo) return <></>

  return (
    <>
      {fulfillment.trackingInfo.map(info => (
        <FulfillmentTrackingRow info={info} key={info.number} />
      ))}
    </>
  )
}

export default function ShopifyDetail({
  navigatableState,
  doNavigatableClearState,
}) {
  const { order = {}, integration = {} } = navigatableState || {}
  const lineItems = useMemo(
    () => {
      return order.lineItems?.edges.map(edge => edge.node)
    },
    [order]
  )

  if (!navigatableState) return null

  const orderId = order.id.replace(/[^\d]*/, '')
  const orderUrl = `https://${
    integration.storeDomain
  }.myshopify.com/admin/orders/${orderId}`

  return (
    <NavigatableIntegrationWidgetCard.Detail
      onBack={doNavigatableClearState}
      title={order.name}
    >
      <p>
        Order ID:
        <a href={orderUrl} target="_blank" rel="noopener noreferrer">
          {orderId}
        </a>
      </p>
      <p>Date: {order.date}</p>
      <p>Payment status: {titleize(order.displayFinancialStatus)}</p>
      <p>Fulfillment status: {titleize(order.displayFulfillmentStatus)}</p>
      {order.requiresShipping && (
        <>
          <p>Shipping:</p>
          {order.fulfillments.map(fulfillment => (
            <FulfillmentRow fulfillment={fulfillment} key={fulfillment.id} />
          ))}
        </>
      )}
      <p>
        <strong>Order details</strong>
      </p>
      {lineItems.map(lineItem => (
        <LineItem
          lineItem={lineItem}
          integration={integration}
          key={lineItem.id}
        />
      ))}
      {order.requiresShipping && (
        <p>Shipping: {moneyString(order.totalShippingPriceSet.shopMoney)}</p>
      )}
      <p>Subtotal: {moneyString(order.currentSubtotalPriceSet.shopMoney)}</p>
      <p>Shipping: {moneyString(order.totalShippingPriceSet.shopMoney)}</p>
      <p>Tax: {moneyString(order.currentTotalTaxSet.shopMoney)}</p>
      <p>Discount: -{moneyString(order.currentTotalDiscountsSet.shopMoney)}</p>
      <p>Total: {moneyString(order.currentTotalPriceSet.shopMoney)}</p>
    </NavigatableIntegrationWidgetCard.Detail>
  )
}
